angular.module('unergie.main')
.controller('newZendeskB2gModalCtrl', ($scope, $filter, $uibModalInstance, AuthService, ApiAdmin, AlertManager, BoFeaturesService, ErrorCatcher, accounts) => {
    const auth = AuthService.getAuth()

    $scope.fetchRequestTypes = () => {
        $scope.loadingIssues = true
        return ApiAdmin.getZendeskB2gTopics().$promise.then((requestTypes) => {
            $scope.zendeskB2GFields = {
                brands: accounts,
                requestTypes: requestTypes.filter((requestType) => requestType !== 'branchement_provisoire').map(requestType => {
                    // dirty hack : on retire le type "Branchement provisoire" pour pas qu'ils puissent faire la demande ici
                    return {       
                        value : requestType,
                        label : (requestType && requestType[1] && requestType[0].toUpperCase() + requestType.slice(1).replaceAll('_',' ')) || (requestType && requestType[0].toUpperCase()) || ''
                    }
                    }),
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.newZendeskB2gTicket = {}
            $scope.loadingIssues = false
        })
    }

    $scope.fetchRequestTypes()


    $scope.confirmZendeskB2gTicketSubmit = () => {
        $scope.saving = true
        $scope.errorMsg = ''
        const zendeskB2gIssue = {
            subject: $scope.newZendeskB2gTicket.subject,
            description: $scope.newZendeskB2gTicket.description,
            prm: $scope.newZendeskB2gTicket.prm,
            organization: $scope.newZendeskB2gTicket.brand.organization,
            customer_id: $scope.newZendeskB2gTicket.brand.customer_id,
            brand: $scope.newZendeskB2gTicket.brand.brand,
            main_topic: $scope.newZendeskB2gTicket.requestType,
        }
        return ApiAdmin.createZendeskB2gTicket(zendeskB2gIssue).$promise.then(() => {
            AlertManager.success('Demande créée')
            $scope.close()
        })
        .catch((err) => {
            AlertManager.error(`Une erreur est survenue lors de l'appel a ZENDSK ${err.data && `: ${err.data.message}`}`, 5000)
        })
        .finally(() => {
            $scope.saving = false
        })
    }

    $scope.print = () => {
        console.log($scope.newZendeskB2gTicket)
    }
    $scope.canCreate = () => {
        return $scope.newZendeskB2gTicket &&
        $scope.newZendeskB2gTicket.subject &&
        $scope.newZendeskB2gTicket.description &&
        $scope.newZendeskB2gTicket.requestType &&
        $scope.newZendeskB2gTicket.brand
    }

    // RETURN OK
    $scope.close = () => $uibModalInstance.close()

    $uibModalInstance.dismiss = $scope.ok
})
